module.exports = __webpack_public_path__ + "static/media/drake_img_4.d7e1e8c9.png";